import {Component, OnInit} from '@angular/core';
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {SupportService} from "../../service/support/support.service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
    frameUrl;
    constructor(private loaderService: LoaderService,
                public sanitizer: DomSanitizer,
                private supportService: SupportService,
                private popupComponent: PopupComponent) {

      window.addEventListener("message", event => {
        if (event.data && event.data.changePage) {
          setTimeout(() => {
            this.iframeLoaded(event.data);
          });
        }
      });

    }

    ngOnInit() {
        this.getChatLink();
    }

    ngAfterViewInit() {
      document.querySelector('.login__content').classList.add('scroll-fix');
    }

    ngOnDestroy() {
      document.querySelector('.login__content').classList.remove('scroll-fix');
    }

    getChatLink() {
        // let djd = {session: "03cd76967c804947b206757249d068e3",
        //     sessionLink: "https://chat.dev.eboxenterprises.com/auth/03cd76967c804947b206757249d068e3",
        //     status: true};
        // this.getChatLinkResult(djd);
        this.supportService.getSession().subscribe(data => {
            this.getChatLinkResult(data);
        }, (error) => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            this.loaderService.hide();
        });
    }

    getChatLinkResult(data) {
        try {
            if (data.status) {
                this.frameUrl = this.getLink(data.sessionLink);
            } else if (data.status === false) {
                this.popupComponent.showPopupError({text: data.message});
            } else {
                this.loaderService.hideAndShowTryAgain();
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }

    }

    getBackLink() {
        // return RouterPaths.rewards.main;
    }

    getLink(url){
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    iframeLoaded(data?) {
      setTimeout(() => {
        const iFrameID: HTMLElement = document.getElementById('iframe');
        const chatFrame: HTMLElement = document.querySelector('.chat-frame');
        (iFrameID as HTMLIFrameElement).contentWindow.postMessage({update: 1}, "*")
        const height = data && data.height ? data.height : 0;
        if(iFrameID && height) {
          // Reset the height first, then set it to the content's height
          chatFrame.style.height = height + "px";
          chatFrame.style.overflow = 'hidden';
          iFrameID.style.overflow = 'hidden';
        }

        if (data && data.scrollEnd) {
          const height = document.querySelector('iframe').scrollHeight;
          // document.querySelector('.login__content').scrollTop = height;
          document.querySelector('.login__content').scrollTo({
            top: height,
            behavior: 'smooth'
          });
        }
      })
    }
}
